import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getCellBgColor} from 'helpers/common-helper';

class TeamDetails extends Component {
    getBackgroundColor(moneyLine) {
        const {sportConfig} = this.props;
        const shadingOptions = sportConfig.getShadingOptions();

        return getCellBgColor(moneyLine, shadingOptions.moneyLine);
    }

    getMoneyLineOfTeam() {
        const {players, teamName} = this.props;
        for (let player of Object.values(players.all())) {
            if (teamName === player.team) {
                return player.moneyLine;
            }
        }
        return 0;
    }

    render() {
        const moneyLine = this.getMoneyLineOfTeam();
        return (
            <div className="moneyline-text" style={{...this.getBackgroundColor(moneyLine)}}>
                <span>
                    MoneyLine: <br />
                    {moneyLine}
                </span>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playersData, sportConfig} = state;
    return {
        players: playersData.players,
        sportConfig,
    };
}

const TeamDetailsComponent = connect(mapStatesToProps)(TeamDetails);

export {TeamDetailsComponent};
